'use strict';

exports.__esModule = true;
exports.default = createErrorLink;

var _apolloLinkError = require('apollo-link-error');

function createErrorLink(handleNetworkError, handleGraphQLError) {
  return (0, _apolloLinkError.onError)(function (_ref) {
    var graphQLErrors = _ref.graphQLErrors,
        networkError = _ref.networkError;

    if (graphQLErrors) {
      graphQLErrors.map(function (graphQLError) {
        return (
          // eslint-disable-next-line no-console
          console.warn('[Apollo | GraphQL error]:', 'Location: ' + graphQLError.locations + '\nPath: ' + graphQLError.path, graphQLError)
        );
      });
      if (handleGraphQLError) {
        handleGraphQLError(graphQLErrors);
      }
    }
    if (networkError) {
      // eslint-disable-next-line no-console
      console.warn('[Apollo | Network error]:', networkError);
      if (handleNetworkError) {
        handleNetworkError(networkError);
      }
    }
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/network/graph-client/link-error.js
// module id = 1133
// module chunks = 0